/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-computed-key */
import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { StudentDetailsContext } from "../store/student-details";
import "../components/CompleteClassDetails.css";
import ModalComponent from "../utils/ModalComponent";
const CompleteClassDetails = () => {
  const StudentContext = useContext(StudentDetailsContext);
  const [addStudent, setAddStudent] = useState(false);
  const [editStudent, setEditStudent] = useState(false);
  // const[loading,setLoading] = useState(false);
  const [editDetailsObj, setEditDetailsObj] = useState({
    Name: "",
    FatherName: "",
    MotherName: "",
    Dob: "",
    AdmissionDate: "",
    AdmissionNumber: "",
    AadharNumber: "",
    MobileNumber: "",
  });
  const { className } = useParams();

  useEffect(() => {
    StudentContext.getDetailsByClassName(className);
    
    
  }, [className]);

  function addStudentHandler() {
    setAddStudent(true);
    StudentContext.created = false;
  }

  function EditCurrentStudentDetails(studentDetails) {
    // console.log('You are editing : '+studentDetails.Name);
    setEditStudent(true);
    StudentContext.isUpdated = false;
    setEditDetailsObj((prevData) => ({
      ...prevData,
      ["Name"]: studentDetails.Name,
      ["FatherName"]: studentDetails.FatherName,
      ["MotherName"]: studentDetails.MotherName,
      ["Dob"]: studentDetails.Dob,
      ["AdmissionNumber"]: studentDetails.AdmissionNumber,
      ["AdmissionDate"]: studentDetails.AdmissionDate,
      ["AadharNumber"]: studentDetails.AadharNumber,
      ["MobileNumber"]: studentDetails.MobileNumber,
    }));

    console.log("Editing Name : " + studentDetails.Name);
  }
  function onClickCancelHandler() {
    setAddStudent(false);
    setEditStudent(false);
    StudentContext.isUpdated = false;
  }

  function addStudentDetailsHandler(studentDetailsObj, className) {
    let admissionId = studentDetailsObj.AdmissionNumber;
    let formBody = studentDetailsObj;
    StudentContext.addDetailsByAdmission(className, admissionId, formBody);
    StudentContext.getDetailsByClassName(className);
  }

  function removeStudentDetailsByAdmissionNumber(data) {
    console.log("Removing student id : ", data.AdmissionNumber);
    StudentContext.deleteDetailsByAdmission(data.AdmissionNumber, className);
  }

  function updateStudentDetailsHandler(className, admissionId, data) {
    StudentContext.updateStudentDetailsByAdmissionNumber(
      className,
      admissionId,
      data
    );
    StudentContext.getDetailsByClassName(className);
  }
  return (
    <div>
      <h5 className="text-center my-5">
        You are viewing class : {className} Details
      </h5>
      {StudentContext.loading ? (
        <>
          <div className="loaderContainer">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </>
      ) : (
        <>
          {StudentContext.studentDetailsByClassName.length === 0 ? (
            <div className="my-5 d-flex flex-column justify-content-center align-items-center ">
              <p>No students data available.</p>
              <button
                className="btn btn-sm btn-warning"
                onClick={addStudentHandler}
                data-toggle="modal"
                data-target="#exampleModal"
              >
                Add Students
              </button>
            </div>
          ) : (
            <div className="container-fluid">
              <div className="row px-5">
                <div className="col-lg-12 d-flex flex-row-reverse px-5">
                  <button
                    className="btn btn-warning btn-sm"
                    onClick={addStudentHandler}
                  >
                    Add Student{" "}
                  </button>
                </div>

                <div className="col-lg-12 mt-5">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th scope="col">S.No</th>
                        <th scope="col">Admission Number</th>
                        <th scope="col">Name</th>
                        <th scope="col">FatherName</th>
                        <th scope="col">MotherName</th>
                        <th scope="col">DOB</th>
                        <th scope="col">Admission Date</th>
                        <th scope="col">Aadhar Number</th>
                        <th scope="col">Mobile Number</th>
                        <th scope="col">Actions</th>
                      </tr>
                    </thead>

                    <tbody>
                      {StudentContext.studentDetailsByClassName.students &&
                        StudentContext.studentDetailsByClassName.students
                          .length > 0 &&
                        StudentContext.studentDetailsByClassName.students.map(
                          (student) => {
                            return (
                              <>
                                <tr>
                                  <td>
                                    {StudentContext.studentDetailsByClassName.students.indexOf(
                                      student
                                    ) + 1}
                                  </td>
                                  <td>{student.AdmissionNumber}</td>
                                  <td>{student.Name}</td>
                                  <td>{student.FatherName}</td>
                                  <td>{student.MotherName}</td>
                                  <td>
                                    {student.Dob !== null
                                      ? new Date(
                                          student.Dob
                                        ).toLocaleDateString()
                                      : ""}
                                  </td>
                                  <td>
                                    {student.AdmissionDate !== null
                                      ? new Date(
                                          student.AdmissionDate
                                        ).toLocaleDateString()
                                      : ""}
                                  </td>
                                  <td>{student.AadharNumber}</td>
                                  <td>{student.MobileNumber}</td>
                                  <td className="d-flex flex-row justify-content-around">
                                    <button
                                      className="btn btn-success"
                                      onClick={(e) => {
                                        EditCurrentStudentDetails(student);
                                      }}
                                    >
                                      Edit
                                    </button>
                                    <button
                                      className="btn btn-danger"
                                      onClick={(e) => {
                                        removeStudentDetailsByAdmissionNumber(
                                          student
                                        );
                                      }}
                                    >
                                      Remove
                                    </button>
                                  </td>
                                </tr>
                              </>
                            );
                          }
                        )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </>
      )}
      {addStudent || editStudent ? (
        <ModalComponent
          className={className}
          editStudent={editStudent}
          addStudent={addStudent}
          onClickCancel={onClickCancelHandler}
          editDetailsObj={editDetailsObj}
          addStudentDetailsHandler={(data, inputClass) => {
            addStudentDetailsHandler(data, inputClass);
          }}
          updateStudentDetailsHandler={(inputClass, admissionId, data) => {
            updateStudentDetailsHandler(inputClass, admissionId, data);
          }}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default CompleteClassDetails;
